import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';

//API
import colegiadoVotacao_api from '../../../../api/colegiadoVotacao_api';

//Helpers
import { showMessage } from '../../../../helpers/message';

//Context
import { useAuth } from '../../../../context/auth';
import CadastroColegiadoVotacao from './components/CadastroColegiadoVotacao';

function ColegiadoVotacao({ permissoes }) {
  //State para criar diário oficial
  const [cadastro, setCadastro] = useState(false);

  //State para pegar o id da contratada
  const [colegiado_id, setColegiado_id] = useState(null);

  //State para lista de colegiados
  const [listColegiadosVotacao, setListColegiadosVotacao] = useState([]);

  const { setLoading } = useAuth();

  const loadColegiadosVotacao = () => {
    setLoading(true);
    colegiadoVotacao_api.getList()
      .then(response => setListColegiadosVotacao(response.data))
      .catch(e => showMessage("Erro", e?.message ?? "Error na operação.", "error", null))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    loadColegiadosVotacao();
  }, []);

  //Variavel de controle de edição da tela
  const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

  //Cabeçalhos da lista de consulta infração
  const headers = [
    { value: "Identificação", objectValue: "identificacao", align: "left" },
    { value: "Status", objectValue: "status", align: "left" }
  ];

  const editarColegiadoVotacao = (rowData) => {
    setColegiado_id(rowData.id);
  }

  const visualizarColegiadoVotacao = (rowData) => {
    setColegiado_id(rowData.id);
  }

  //Ações que a tabela terá
  const actions = [
    ...editavel
      ? [actionsTable.editar(editarColegiadoVotacao)]
      : [actionsTable.visualizar(visualizarColegiadoVotacao)]
  ];


  const handleVoltar = () => {
    setCadastro(false);
    setColegiado_id(null);
    loadColegiadosVotacao();
  }

  if (colegiado_id || cadastro) {
    return <CadastroColegiadoVotacao
      id={colegiado_id}
      handleVoltar={handleVoltar}
      editavel={editavel}
    />
  }

  return <>
    <div className='d-flex align-items-center justify-content-between mb-4'>
      <h4 className='text-secondary m-0'>Colegiado de votação</h4>
      {editavel &&
        <Button color='success' onClick={() => {
          setCadastro(true);
        }}>+ Cadastrar
        </Button>
      }
    </div>
    <TabelaListagem
      actions={actions}
      title={"Lista de colegiado votação"}
      options={{ print: false, search: true, pagination: true }}
      headers={headers}
      items={listColegiadosVotacao}
    />
  </>;
}

export default ColegiadoVotacao;